import Vue from 'vue'

import types from '../types'

const state: {
  active: number
} = {
  active: 0
}

const getters = {
}

const actions = {
}

const mutations = {
  [types.mutations.NAVIGATION_ACTIVE](state: any, active: number): void {
    Vue.set(state, 'active', active)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
